import { render } from "./StatisticsItem.vue?vue&type=template&id=d7577be8&scoped=true"
import script from "./StatisticsItem.vue?vue&type=script&lang=js"
export * from "./StatisticsItem.vue?vue&type=script&lang=js"

import "./StatisticsItem.vue?vue&type=style&index=0&id=d7577be8&lang=less&scoped=true"

import exportComponent from "/Users/a/k618/work/sxdsjtj/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7577be8"]])

export default __exports__